import React from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faTwitter, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons'

const Footer = ({ fluid, hideMenu }) => {

	return (
		<footer className="border-top">

			<div className={'container' + (fluid ? '-fluid' : '')}>

				<div className="d-flex flex-row justify-content-between">
					<div className="py-3"><span className="text-muted">©2022 <a href={process.env.MIX_APP_URL}>AdSitePro.com</a>. All Rights Reserved</span></div>
					{!hideMenu &&
						<div className="py-3">
							<>
								<Link tag="a" className="ms-2 text-muted" to={'/article/help'}>Help</Link>
								<Link tag="a" className="ms-2 text-muted" to={'/article/privacy'}>Privacy</Link>
								<Link tag="a" className="ms-2 text-muted" to={'/article/terms'}>Terms</Link>
								<Link tag="a" className="ms-2 text-muted" to={'/article/affiliate-program'}>Rewards program</Link>
								<Link tag="a" className="ms-2 text-muted" to={'/article/posting-rules'}>Posting Rules</Link>
								<Link tag="a" className="ms-2 text-muted" to={'/article/about'}>About</Link>
								<a className="ms-2 text-muted" href="/feedback">Feedback</a>
								<a className="ms-2 text-muted" target="_blank" href={process.env.MIX_APP_URL + '/sitemap/index.xml'}>Sitemap</a>
							</>
						</div>
					}
				</div>
				<div className="pb-3">
					<span className="me-2 text-muted">Follow us on: </span>
					<a className="me-2 text-muted" href="https://www.facebook.com/AdSitePro-155764169623128" target="_blank" rel="noindex">
						<FontAwesomeIcon icon={faFacebook} className="me-1" />
						Facebook
					</a>
					<a className="me-2 text-muted" href="https://twitter.com/adsitepro" target="_blank" rel="noindex">
						<FontAwesomeIcon icon={faTwitter} className="me-1" />
						Twitter
					</a>
					<a className="me-2 text-muted" href="https://www.instagram.com/adsitepro" target="_blank" rel="noindex">
						<FontAwesomeIcon icon={faInstagram} className="me-1" />
						Instagram
					</a>
					<a className="me-2 text-muted" href="https://youtube.com/channel/UCFjIQbwGn9goq8bidXKgxyA" target="_blank" rel="noindex">
						<FontAwesomeIcon icon={faYoutube} className="me-1" />
						YouTube
					</a>
				</div>
			</div>
    	</footer>
    )
}

export default Footer
